<div class="munkaido">

  <!-- Fejléc + hónapváltó (08-munkaido.html) -->
  <div class="wt-head">
    <div class="wt-head__titles">
      <h1 class="stk-page-title">Munkaidő</h1>
      <div class="stk-page-sub">A saját munkaidőd, szabadságaid és várható béred.</div>
    </div>
    <div class="wt-month-nav">
      <button type="button" class="wt-month-nav__btn" title="Előző hónap" (click)="prevMonth()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="14,6 8,12 14,18"></polyline></svg>
      </button>
      <span class="wt-month-nav__label">{{ monthLabel }}</span>
      <button type="button" class="wt-month-nav__btn" title="Következő hónap" (click)="nextMonth()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="10,6 16,12 10,18"></polyline></svg>
      </button>
    </div>
  </div>

  <!-- Saját user sáv (wtIsEmployee) -->
  <div class="wt-me">
    <span class="wt-avatar" [style.background]="ownColor" [appUserAvatar]="ownName">{{ ownInitial }}</span>
    <span class="wt-me__name">{{ ownName }}</span>
    <span class="wt-ext-pill" *ngIf="isExternal">Külsős</span>
    <span class="wt-me__hint">— csak a saját munkaidődet látod</span>
  </div>

  <!-- Havi kártyák (wtKpis) — külsősnél nincs szabadság / betegszabadság -->
  <div class="wt-kpis" [class.wt-kpis--three]="isExternal">
    <div class="wt-kpi" *ngFor="let k of kpis">
      <div class="wt-kpi__label">{{ k.label }}</div>
      <div class="wt-kpi__value" [style.color]="k.valColor">{{ k.value }}</div>
      <div class="wt-kpi__sub">{{ k.sub }}</div>
    </div>
  </div>

  <!-- Havi naptár (wtCells) -->
  <div class="wt-cal">
    <div class="wt-cal__heads">
      <div class="wt-cal__head" *ngFor="let d of dayHeads">{{ d }}</div>
    </div>
    <div class="wt-cal__grid">
      <ng-container *ngFor="let c of cells">
        <div *ngIf="c.blank"></div>
        <div *ngIf="!c.blank"
             class="wt-cell"
             [class.wt-cell--weekend]="c.weekend"
             [class.wt-cell--vacation]="c.kind === 'vacation'"
             [class.wt-cell--sick]="c.kind === 'sick'"
             [class.wt-cell--absence]="c.kind === 'absence'"
             [class.wt-cell--planned]="c.kind === 'planned'"
             [class.wt-cell--today]="c.today"
             (click)="openDay(c)">
          <div class="wt-cell__top">
            <span class="wt-cell__num"
                  [class.wt-cell__num--weekend]="c.weekend"
                  [class.wt-cell__num--today]="c.today">{{ c.num }}</span>
            <span class="wt-cell__spacer"></span>
            <svg *ngIf="c.hasComment" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 1 0 -3.1 6.3 L21 20 Z"></path></svg>
          </div>
          <div class="wt-cell__time" *ngIf="c.timeLabel">{{ c.timeLabel }}</div>
          <div *ngIf="c.typeLabel"><span class="wt-pill {{ c.pillClass }}">{{ c.typeLabel }}</span></div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Előre jelzett távollétek (heti ismétlődő vagy egyszeri) -->
  <app-wt-plans [userId]="plansUserId" (changed)="reload()"></app-wt-plans>

  <!-- Nap modál -->
  <div class="wt-modal-overlay" *ngIf="draft" (click)="closeDay()">
    <div class="wt-modal" (click)="$event.stopPropagation()">
      <div class="wt-modal__head">
        <h2 class="wt-modal__title">{{ modalTitle }}</h2>
        <button type="button" class="wt-modal__close" title="Bezárás" (click)="closeDay()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>

      <div class="wt-type-chips" [class.wt-type-chips--single]="isExternal">
        <button *ngFor="let c of visibleTypeChips"
                type="button"
                class="wt-type-chip"
                [class.wt-type-chip--active]="draft.type === c.t"
                (click)="setDraftType(c.t)">{{ c.label }}</button>
      </div>
      <div class="wt-type-hint" *ngIf="isExternal">Külsősként munkanapot vagy távollétet rögzíthetsz — nincs szabadság-elszámolás.</div>

      <div class="wt-type-hint" *ngIf="modalPlan">{{ modalPlanLabel }}</div>

      <ng-container *ngIf="draft.type === 'absence'">
        <div class="wt-times">
          <div>
            <div class="wt-field__label">Távol ettől</div>
            <input type="time" class="wt-field__input" [value]="draft.start" (change)="onStartChange($event)">
          </div>
          <div>
            <div class="wt-field__label">Eddig</div>
            <input type="time" class="wt-field__input" [value]="draft.end" (change)="onEndChange($event)">
          </div>
        </div>
        <div class="wt-field__hint wt-absence-hint">Üresen hagyva egész napos távollét. Nem fizetett, a szabadságkeretet nem érinti.</div>
      </ng-container>

      <ng-container *ngIf="draft.type === 'work'">
        <div class="wt-times">
          <div>
            <div class="wt-field__label">Munkakezdés</div>
            <input type="time" class="wt-field__input" [value]="draft.start" (change)="onStartChange($event)">
          </div>
          <div>
            <div class="wt-field__label">Munka vége</div>
            <input type="time" class="wt-field__input" [value]="draft.end" (change)="onEndChange($event)">
            <div class="wt-field__hint">Hagyd üresen, ha még dolgozol — távozáskor írd be.</div>
          </div>
        </div>
        <div class="wt-draft-hours"
             [class.wt-draft-hours--done]="draftDone && !draftInvalidRange"
             [class.wt-draft-hours--error]="draftInvalidRange">{{ draftHours }}</div>
      </ng-container>

      <div class="wt-comment">
        <div class="wt-field__label">Komment</div>
        <textarea rows="2" placeholder="pl. Csütörtökön el kell mennem 2 órára…" [value]="draft.comment" (input)="onCommentChange($event)"></textarea>
      </div>

      <div class="wt-modal-actions">
        <button *ngIf="modalHadEntry" type="button" class="wt-btn-delete" (click)="deleteDay()">Bejegyzés törlése</button>
        <span class="wt-modal-actions__spacer"></span>
        <button type="button" class="wt-btn-cancel" (click)="closeDay()">Mégse</button>
        <button type="button" class="wt-btn-save" [disabled]="draftInvalidRange || saving" (click)="saveDay()">Mentés</button>
      </div>
    </div>
  </div>

</div>
